module.exports = __webpack_public_path__ + "img/service-sp-screen-plot.4a22957f.png";